import { createApp } from 'vue';

export default {
    name : 'header',
    init() {
        const app = createApp({

            data() {
                return {
                    menuToggled : false,
                    menuAnimated : false,
                    searchToggled : false,
                };
            },

            computed :
            {
                isMenuToggled() {
                    return (this.menuToggled) ? ' active ' : '';
                },

                isSearchToggled() {
                    return (this.searchToggled) ? ' active ' : '';
                },
            },

            methods:
            {
                toggleMenu(event) {
                    this.menuToggled = (this.menuToggled) ? false : true;
                },

                toggleSearch(event) {
                    this.searchToggled = (this.searchToggled) ? false : true;
                    if(this.searchToggled){
                        console.log(this.$refs.searchbar);
                        this.$refs.searchbar.focus();
                        window.setTimeout(() => this.$refs.searchbar.focus(), 0);
                    }
                },

            },
            created ()
            {
                // _log('header ready');
            }
        });

        app.mount('#header');


    }
}